<template>
    <v-layout wrap
              justify-space-around
              align-start
              class="notifications_block"
    >
        <v-flex row class="notifications__img-block"
                xs3 ld2 md2
        >
            <div class="norifications_img" :style="{backgroundImage: `url(${url + info.avatar})`}">
                <div class="norifications_img" :style="{backgroundImage: `url(${url + info.avatar})`}"></div>
            </div>
        </v-flex>
        <v-flex column class="notifications_body"
                ld10
                md10 xs9
        >
            <a>
                <v-layout row class="notifications__title-row" wrap
                          justify-space-between
                >
                    <v-flex row class="notifications__title"
                            xs12 ld6 md6
                    >
                        {{ info.title }}
                    </v-flex>
                    <v-flex ld6 md6 xs12>
                        <v-layout justify-start>
                            <v-flex row class="notifications__date" justify-end
                                    xs4 ld6 md4
                            >
                                {{ info.date | day }}
                            </v-flex>
                            <v-flex xs4 md4>
                                <span class="notifications_time">
                                    {{ info.date | time }}
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </a>
<!--            <v-flex row xs12 md12
                    class="notifications__descr"
            >
                <span v-html="info.description"></span>
            </v-flex>-->
        </v-flex>
        <v-flex row class="notifications__descr descr-mobile" xs12
        >
            <span v-html="info.description"></span>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import orderby from 'lodash.orderby';

export default {
  name : 'NotificationRecord',
  props: {
    'info': Object,
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
  },
  methods: {
    ...mapMutations('news_main', [
      'SET_CURRENT_ID',
    ]),
    ...mapMutations('notifications/Notifications_items', [
      'SET_READ_MESSAGE',
    ]),
    ...mapActions('notifications/Notifications_items', [
      'set_read_note',
    ]),
    go_to(item) {
      this.$emit('emit_go_to', item);
    },
    async click_notifications(item, open) {
      const {id, notification_id} = item;

      this.SET_CURRENT_ID(id);
      this.SET_READ_MESSAGE(item);

      await this.set_read_note(notification_id);
    },
  },
};
</script>
